import { InitAdapter, SubmitAdapter } from '../../../types';
import { GallerySelectItem } from '../../../common/GalleryMultiselect';
import { PapiGallection } from '@wix/da-papi-types';

export const initAdapter: InitAdapter = ({
  galleries: allGalleries = [],
  inGalleries = [],
}): GallerySelectItem[] | undefined => {
  const isSelected = (gallery: PapiGallection) => {
    return inGalleries.some(g => g.folderId === gallery.folderId);
  };

  return allGalleries.map(gallery => ({
    gallery,
    value: `${gallery.folderId}`,
    selected: isSelected(gallery),
  }));
};

export const submitAdapter: SubmitAdapter = ({ galleries = [] }) => ({
  galleryids: galleries.filter(item => item.selected).map(({ value }) => value),
});
